"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsAgentsInsightsResponse$ = exports.StatsAgentsInsightsResponse$outboundSchema = exports.StatsAgentsInsightsResponse$inboundSchema = void 0;
exports.statsAgentsInsightsResponseToJSON = statsAgentsInsightsResponseToJSON;
exports.statsAgentsInsightsResponseFromJSON = statsAgentsInsightsResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const statsagentsinsightswrapper_js_1 = require("./statsagentsinsightswrapper.js");
/** @internal */
exports.StatsAgentsInsightsResponse$inboundSchema = z.object({
    data: statsagentsinsightswrapper_js_1.StatsAgentsInsightsWrapper$inboundSchema,
});
/** @internal */
exports.StatsAgentsInsightsResponse$outboundSchema = z.object({
    data: statsagentsinsightswrapper_js_1.StatsAgentsInsightsWrapper$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var StatsAgentsInsightsResponse$;
(function (StatsAgentsInsightsResponse$) {
    /** @deprecated use `StatsAgentsInsightsResponse$inboundSchema` instead. */
    StatsAgentsInsightsResponse$.inboundSchema = exports.StatsAgentsInsightsResponse$inboundSchema;
    /** @deprecated use `StatsAgentsInsightsResponse$outboundSchema` instead. */
    StatsAgentsInsightsResponse$.outboundSchema = exports.StatsAgentsInsightsResponse$outboundSchema;
})(StatsAgentsInsightsResponse$ || (exports.StatsAgentsInsightsResponse$ = StatsAgentsInsightsResponse$ = {}));
function statsAgentsInsightsResponseToJSON(statsAgentsInsightsResponse) {
    return JSON.stringify(exports.StatsAgentsInsightsResponse$outboundSchema.parse(statsAgentsInsightsResponse));
}
function statsAgentsInsightsResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.StatsAgentsInsightsResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StatsAgentsInsightsResponse' from JSON`);
}
//# sourceMappingURL=statsagentsinsightsresponse.js.map